import { createSlice } from "@reduxjs/toolkit";
import VwHbsBransDTO from "src/models/Settings/Generals/VwHbsBransDTO";
import VwHbsServisveriDTO from "src/models/Settings/Generals/VwHbsServisveriDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IBransTanim {
    open: boolean;
    activeRow: VwHbsBransDTO;
    servisVeriEkleOpen: boolean;
    servisVeriActiveRow?: VwHbsServisveriDTO;
};

export const BransTanimSlice = createSlice<IBransTanim, MapReducerPayloads<IBransTanim, {
    setOpen: boolean;
    setActiveRow: VwHbsBransDTO;
    setServisVeriEkleOpen: boolean;
    setServisVeriActiveRow?: VwHbsServisveriDTO;
}>>({
    name: "bransTanim",
    initialState: {
        open: false,
        activeRow: new VwHbsBransDTO(),
        servisVeriEkleOpen: false,
        servisVeriActiveRow: new VwHbsServisveriDTO(),
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setServisVeriEkleOpen: (state, action) => {
            state.servisVeriEkleOpen = action.payload;
        },
        setServisVeriActiveRow: (state, action) => {
            state.servisVeriActiveRow = action.payload;
        },
    },
});